/* src/app/component/post/post.component.css */
/*# sourceMappingURL=post.component.css.map */
